import { Controller } from '@hotwired/stimulus'
import { get } from '@rails/request.js'

// Connects to data-controller="business-repository--code"
export default class extends Controller {
  static targets = ['input', 'prefix']
  static values = { url: String }

  async updatePrefix (event) {
    const response = await get(
      `${this.urlValue}?group_id=${event.target.value}`,
      { responseKind: 'json' })
    if (response.ok) {
      const json = await response.json
      this.prefixTarget.innerText = json.code_prefix
      this.inputTarget.placeholder = json.code_placeholder
    }
  }
}
